import { getDistributionPolicyFlags } from '@shared/entities/rewardPool';

import { RewardPool } from '@api/types/rewardPools';

import { isRewardPoolActive } from '@store:web/components/entities/rewardPool';

export const checkEligibilityToJoin = (rewardPool: RewardPool): boolean => {
  const { isFcfs, isRaffle, isProRata } = getDistributionPolicyFlags(
    rewardPool.distribution_policy,
  );
  const availableSlots = (rewardPool.participants_max || 0) - rewardPool.participants_counter;

  const hasAvailableSlotsForFcfs = isFcfs && availableSlots > 0;

  const hasAvailableSlotsForRaffle =
    isRaffle && (!rewardPool.participants_max || availableSlots > 0);

  const hasAvailableSlots = isProRata || hasAvailableSlotsForFcfs || hasAvailableSlotsForRaffle;

  const isActive = isRewardPoolActive(rewardPool);

  return isActive && hasAvailableSlots;
};
